import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';

const StudentDeactivate = () => {
  const { studentId } = useParams(); // Extract studentId from the URL
  const [studentDetails, setStudentDetails] = useState(null);
  const [ledger, setLedger] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showLedgerDetails, setShowLedgerDetails] = useState(false);
  const navigate = useNavigate();
  const [eligibility, setEligibility] = useState(null);


  useEffect(() => {
    const sessionId = localStorage.getItem("currentSessionId");

axios
  .get(
    `${process.env.REACT_APP_API_BASE_URL}/api/students/checkDeactivateEligibility/${studentId}`,
    { params: { sessionId } }
  )
  .then(res => setEligibility(res.data))
  .catch(err => console.error(err));

    const fetchStudentData = async () => {
      try {
        setLoading(true);
        // Fetch student details by studentId
        const studentResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/students/getStudents/${studentId}`);
        setStudentDetails(studentResponse.data);
const sessionId = localStorage.getItem("currentSessionId");
        // Fetch ledger details by studentId
        const ledgerResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/ledgers/getLedgerByStudentId/${studentId}`,
          {
    params: { sessionId }
  }
        );
        setLedger(ledgerResponse.data);

        setLoading(false);
      } catch (err) {
        setError('Failed to fetch data.');
        setLoading(false);
      }
    };

    fetchStudentData();
  }, [studentId]);

  if (loading) return <div className="flex items-center justify-center h-screen">Loading...</div>;
  if (error) return <div className="text-red-600 text-center">Error: {error}</div>;

  const handleShowLedger = () => {
    navigate(`/ledger/${studentId}`);
  };

  const handlePayFee = () => {
    // Placeholder for pay fee functionality
    navigate(`/fee-collection`);
  };

  const handleDeactivate = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/students/updateStudentStatus/${studentId}`, { status: "Inactive" })
      .then(response => {
        if (response.status === 200) {
          alert('Student account has been successfully deactivated.');
        }
      })
      .catch(error => {
        console.error('There was an error deactivating the student account:', error);
        alert('An error occurred while deactivating the student account. Please try again.');
      });
  };

  const handleActivate = () => {
    axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/students/updateStudentStatus/${studentId}`, { status: "active" })
      .then(response => {
        if (response.status === 200) {
          alert('Student account has been successfully activated.');
        }
      })
      .catch(error => {
        console.error('There was an error activating the student account:', error);
        alert('An error occurred while activating the student account. Please try again.');
      });
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-center text-gray-700">Deactivate/Activate Student</h1>
          <p className="text-center text-gray-500">Review student details and ledger balance before deactivating or activating.</p>
        </div>

        {/* Student Details Card */}
        <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
          <h2 className="text-2xl font-semibold mb-4 border-b pb-2">Student Details</h2>
          {studentDetails ? (
            <div className="flex items-center">
              <img
                src={studentDetails.image || 'https://via.placeholder.com/100'}
                alt="Profile"
                className="w-24 h-24 rounded-full shadow-md border mr-6"
              />
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p><strong>Name:</strong> {studentDetails.firstName} {studentDetails.lastName}</p>
                  <p><strong>Student ID:</strong> {studentDetails._id}</p>
                  <p><strong>Father's Name:</strong> {studentDetails.fatherName}</p>
                  <p><strong>Mother's Name:</strong> {studentDetails.motherName}</p>
                </div>
                <div>
                  <p><strong>Email:</strong> {studentDetails.email}</p>
                  <p><strong>Phone No:</strong> {studentDetails.phoneNo}</p>
                  <p><strong>Alternate Phone No:</strong> {studentDetails.phoneNo2}</p>
                  <p><strong>Gender:</strong> {studentDetails.gender}</p>
                </div>
                <div>
                  <p><strong>Date of Birth:</strong> {new Date(studentDetails.dob).toLocaleDateString()}</p>
                  <p><strong>Age:</strong> {studentDetails.age}</p>
                  <p><strong>Address:</strong> {studentDetails.address}, {studentDetails.city}, {studentDetails.state}</p>
                </div>
                <div>
                  <p><strong>Enrollment Date:</strong> {new Date(studentDetails.enrollmentDate).toLocaleDateString()}</p>
                  <p><strong>Class:</strong> {studentDetails.class}</p>
                  <p><strong>Section:</strong> {studentDetails.section}</p>
                  <p><strong>Roll No:</strong> {studentDetails.rollNo}</p>
                </div>
              </div>
            </div>
          ) : (
            <p>No student details available.</p>
          )}
        </div>

        {/* Ledger Balance Card */}
        <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
          <h2 className="text-2xl font-semibold mb-4 border-b pb-2">Ledger Balance</h2>
          {ledger ? (
            <div>
              <p><strong>Total Balance:</strong> ₹{ledger.totalAmount}</p>
              <p><strong>Pending Balance:</strong> ₹{ledger.balance}</p>
              <button
                onClick={handleShowLedger}
                className="mt-4 px-4 py-2 bg-blue-500 hover:bg-blue-700 text-white font-semibold rounded-lg"
              >
                {showLedgerDetails ? 'Hide Ledger Details' : 'Show Ledger Details'}
              </button>
            </div>
          ) : (
            <p>No ledger details available.</p>
          )}
        </div>
<div className="bg-white shadow-lg rounded-lg p-6 mb-6">
  <h2 className="text-2xl font-semibold mb-4 border-b pb-2">
    Fee Clearance Status
  </h2>

  {eligibility && (
    <>
      <p>
        <strong>Monthly Fee:</strong>{" "}
        {eligibility.monthlyCleared ? (
          <span className="text-green-600">Cleared</span>
        ) : (
          <span className="text-red-600">Pending</span>
        )}
      </p>

      <p>
        <strong>Other Heads:</strong>{" "}
        {eligibility.otherHeadsPending ? (
          <span className="text-red-600">Pending</span>
        ) : (
          <span className="text-green-600">Cleared</span>
        )}
      </p>

      <p>
        <strong>Ledger Balance:</strong>{" "}
        {!eligibility.canDeactivate ? (
          <span className="text-red-600">₹{eligibility.balance}</span>
        ) : (
          <span className="text-green-600">Cleared</span>
        )}
      </p>
    </>
  )}
</div>

        {/* Actions */}
        <div className="bg-white shadow-lg rounded-lg p-6 mb-6">
          <div className="flex justify-between gap-4">
            <button
              onClick={handlePayFee}
              disabled={ledger && ledger.balance <= 0}
              className={`w-full py-3 text-white font-semibold rounded-lg text-lg ${ledger && ledger.balance <= 0 ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-500 hover:bg-green-700'}`}
            >
              {ledger && ledger.balance <= 0 ? 'Fee Paid' : 'Pay Fee'}
            </button>
            <button
  disabled={!eligibility?.canDeactivate}
  onClick={
    studentDetails && studentDetails.status === 'active'
      ? handleDeactivate
      : handleActivate
  }
  className={`w-full py-3 text-white font-semibold rounded-lg text-lg 
    ${
      !eligibility?.canDeactivate
        ? 'bg-gray-400 cursor-not-allowed'
        : studentDetails && studentDetails.status === 'active'
        ? 'bg-red-500 hover:bg-red-700'
        : 'bg-green-500 hover:bg-green-700'
    }`}
>
  {!eligibility?.canDeactivate
    ? 'Cannot Deactivate (Fee Pending)'
    : studentDetails && studentDetails.status === 'active'
    ? 'Deactivate Student'
    : 'Activate Student'}
</button>

          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentDeactivate;
